import React, { useState } from 'react';
import { TiSocialInstagram, TiSocialFacebook } from 'react-icons/ti';
import logo from '../../assets/images/logo3.png';
import logoMini from '../../assets/images/logo-mini.png';
import footer from '../../assets/images/footer.png';
import {
  Burger,
  Menu,
  Header,
  Figure,
  BurgerInner,
  Column,
  Container,
  Copyright,
  Footer,
  FooterImage,
  FooterWrapper,
  GridLayout,
  ImageFull,
  ImageMini,
  Main,
  MenuItem,
  MenuLink,
  Nav,
  Social,
} from './styles';

const Layout = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenuOpen = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <GridLayout>
      <Header>
        <Container>
          <Figure>
            <ImageFull src={logo} />
            <ImageMini src={logoMini} />
          </Figure>
          <Nav open={menuOpen}>
            <Menu>
              <MenuItem>
                <MenuLink to="/" onClick={() => toggleMenuOpen()}>
                  Início
                </MenuLink>
              </MenuItem>
              <MenuItem>
                <MenuLink to="/contato" onClick={() => toggleMenuOpen()}>
                  Lojas
                </MenuLink>
              </MenuItem>
              <Social>
                <a
                  href="https://www.instagram.com/sorveterianewaska/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TiSocialInstagram size={30} color="294c7c" />
                </a>
                <a
                  href="https://www.facebook.com/sorveterianewaskacachoeirinha"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TiSocialFacebook size={30} color="294c7c" />
                </a>
              </Social>
            </Menu>
          </Nav>
          <Burger onClick={() => toggleMenuOpen()} open={menuOpen}>
            <BurgerInner open={menuOpen} />
          </Burger>
        </Container>
      </Header>
      <Main>{children}</Main>
      <Footer>
        <FooterWrapper>
          <Column>
            <FooterImage src={footer} />
          </Column>
          <Column>
            <Copyright>
              Sorveteria Newaska. Todos os direitos reservados.{' '}
              {new Date().getFullYear()}.
            </Copyright>
          </Column>
          <Column>
            <Social>
              <a
                href="https://www.instagram.com/sorveterianewaska/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TiSocialInstagram size={40} color="#FFF" />
              </a>
              <a
                href="https://www.facebook.com/sorveterianewaskacachoeirinha"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TiSocialFacebook size={40} color="#FFF" />
              </a>
            </Social>
          </Column>
        </FooterWrapper>
      </Footer>
    </GridLayout>
  );
};

export default Layout;
